
document.querySelectorAll('.footer-block__heading').forEach(heading => {
  heading.addEventListener('click', () => {
    const block = heading.parentElement;
    document.querySelectorAll('.footer-block').forEach(el => {
      if (el !== block) el.classList.remove('active');
    });
    block.classList.toggle('active');
  });
});
